import React from 'react';

function VotePage(props) {
    var pkg = props.packageName || '';
    var app = props.app;
    var voteFormType = props.voteFormType || 'up';
    var voteFormInstalled = !!props.voteFormInstalled;
    var voteFormCrashed = !!props.voteFormCrashed;
    var voteFormComment = props.voteFormComment || '';

    if (!pkg) {
        return React.createElement('div', { className: 'bb-empty' }, 'Missing package to vote on.');
    }
    if (!props.user) {
        return React.createElement('div', { className: 'bb-empty' }, 'Please log in to vote.');
    }

    return React.createElement('div', { className: 'container py-3' },
        React.createElement('div', { className: 'bb-profile-card' },
            React.createElement('h4', { className: 'vote-heading' },
                'Vote ',
                (voteFormType === 'down' ? '👎' : '👍'),
                ' for ',
                React.createElement('img', {
                    className: 'vote-app-icon',
                    src: (app && app.icon_url) ? app.icon_url : '',
                    alt: (app && app.app_name) ? app.app_name : pkg
                }),
                React.createElement('span', { className: 'vote-app-name' }, app ? app.app_name : pkg)
            ),
            React.createElement('div', { className: 'vote-package-row' },
                React.createElement('span', { className: 'bb-chip' }, pkg)
            ),
            React.createElement('form', { onSubmit: props.onSubmit },
                voteFormType === 'down' && React.createElement('div', { className: 'form-group' },
                    React.createElement('label', null, 'Did the app install?'),
                    React.createElement('div', { className: 'bb-chip-select-row' },
                        React.createElement('button', {
                            type: 'button',
                            className: 'bb-chip-btn bb-chip-yes' + (voteFormInstalled === true ? ' active' : ''),
                            onClick: function() { props.onFieldChange('voteFormInstalled', true); }
                        }, 'Yes'),
                        React.createElement('button', {
                            type: 'button',
                            className: 'bb-chip-btn bb-chip-no' + (voteFormInstalled === false ? ' active' : ''),
                            onClick: function() { props.onFieldChange('voteFormInstalled', false); }
                        }, 'No')
                    )
                ),
                voteFormType === 'down' && voteFormInstalled === true && React.createElement('div', { className: 'form-group' },
                    React.createElement('label', null, 'Did the app crash?'),
                    React.createElement('div', { className: 'bb-chip-select-row' },
                        React.createElement('button', {
                            type: 'button',
                            className: 'bb-chip-btn bb-chip-yes' + (voteFormCrashed === true ? ' active' : ''),
                            onClick: function() { props.onFieldChange('voteFormCrashed', true); }
                        }, 'Yes'),
                        React.createElement('button', {
                            type: 'button',
                            className: 'bb-chip-btn bb-chip-no' + (voteFormCrashed === false ? ' active' : ''),
                            onClick: function() { props.onFieldChange('voteFormCrashed', false); }
                        }, 'No')
                    )
                ),
                React.createElement('div', { className: 'form-group' },
                    React.createElement('label', null, voteFormType === 'down' ? 'Comment (required)' : 'Comment (optional)'),
                    React.createElement('textarea', {
                        className: 'bb-vote-textarea',
                        value: voteFormComment,
                        onChange: function(e) { props.onFieldChange('voteFormComment', e.target.value); },
                        rows: 3
                    })
                ),
                React.createElement('button', { type: 'submit', className: 'bb-btn bb-btn-primary bb-btn-sm' }, 'Submit vote'),
                React.createElement('button', { type: 'button', className: 'bb-btn bb-btn-secondary bb-btn-sm ml-2', onClick: props.onCancel }, 'Cancel')
            )
        )
    );
}

export default VotePage;
